import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3400To3499Service {

  constructor() { }
}
